import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

export const useRemoveUser = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data) => api.users.setUserDisable(id, data),
    onError: (error) => {
      toaster.create({
        title: 'Не удалось изменить статус пользователя',
        description: error?.message,
        type: 'error',
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Пользователь успешно заблокирован',
        type: 'success',
      })
      queryClient.invalidateQueries({ queryKey: ['userCard'] })
    },
  })
}
